export const MINIMIZED_TITLE = 'Упражнение';
export const MINIMIZED_DESC = 'Автопроверка';
